"use client";

import Script from "next/script";
import type { ScriptProps } from "next/script";
import { useEffect, useState } from "react";
import { useConsentStore } from "@/app/stores/consent-store";

type Props = ScriptProps & {
  category: "functional" | "analytics" | "marketing";
  fallback?: React.ReactNode;
};

export default function ScriptWithConsent({
  category,
  fallback = null,
  ...props
}: Props) {
  const { consent } = useConsentStore();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!consent) return;
    setAllowed(Boolean(consent.preferences[category]));
  }, [consent, category]);

  if (!allowed) return fallback;
  return <Script {...props} />;
}
